/* eslint-disable sonarjs/no-duplicate-string */
import { CustomerInfoForm } from '@/components/Layout';
import { FormikErrors } from 'formik';
import isEmailValid from './email';
import { t } from 'i18next';

export const validateNameField = (value: string | undefined) => {
  if (!value?.trim()) return t('error.invalid_name');
  return undefined;
};

export const validateEmailField = (value: string | undefined) => {
  if (!value?.trim()) return t('error.invalid_email');
  if (!isEmailValid(value)) return t('error.invalid_email');
  return undefined;
};
export const validateCustomerForm = (customerForm: CustomerInfoForm) => {
  const errors: FormikErrors<CustomerInfoForm> = {};
  if (!customerForm.name) {
    errors.name = t('error.invalid_name');
  }
  if (!customerForm.email || !isEmailValid(customerForm.email)) {
    errors.email = t('error.invalid_email');
  }
  return errors;
};
